'use client'

import groupImg from '@/public/images/v2/Group.png'
import { IArticle } from '@/api/interfaces/IArticle'
import { WithT } from '@/locales/types'
import { createT } from '@/locales/index'
import { GroupSlider } from '../GroupSlider'
import ArticleRelatedVirtualCard from './ArticleRelatedVirtualCard'
import { ImageWithFallback } from '../ImageWithFallback'

interface IArticleReleatedVirtualSlider {
  items: IArticle.IRelatedUser[]
}

export const ArticleRelatedVirtualSlider = ({
  items,
  translations,
}: WithT<IArticleReleatedVirtualSlider>) => {
  const t = createT(translations)

  return (
    <div className="flex flex-col gap-3 py-3">
      <div className="flex gap-2 items-center">
        <ImageWithFallback
          src={groupImg}
          alt="아래를 향한 손가락 이미지"
          width={20}
          height={20}
        />
        <span className="text-subtitle1 font-bold">
          {t('article.relatedVirtual.title')}
        </span>
      </div>

      <GroupSlider
        id="article-related-virtual"
        groupItemCount={3}
        items={items}
        keyFn={(item) => item.id}
        render={(item) => (
          <ArticleRelatedVirtualCard item={item} translations={translations} />
        )}
      />
    </div>
  )
}
